document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".cards");
  const buttons = `
  <div class="cards-navigation-dots"></div>
  <div class="cards-navigation-arrows">
      <button class="cards-navigation-arrows-prev" aria-label="Nach rechts scrollen"></button>
      <button class="cards-navigation-arrows-next" aria-label="Nach links scrollen"></button>
  </div>`;
  cards.forEach((cardsEl) => {
    cardsEl.insertAdjacentHTML("beforeend", buttons);
  });
  cards.forEach(paralaxBackground);
  cards.forEach(navigation);
});

function paralaxBackground(wrapperEl) {
  const cardEls = wrapperEl.querySelectorAll(".card");
  const innerEl = wrapperEl.querySelector(".cards-inner");
  let scrollPadding = 0;

  const updateOffsets = () => {
    const containerWidth = innerEl.getBoundingClientRect().width;
    cardEls.forEach((cardEl) => {
      const offset = Math.min(
        Math.max(
          (scrollPadding - cardEl.getBoundingClientRect().left) /
            containerWidth,
          -1
        ),
        1
      );
      cardEl.style.setProperty("--offset", offset);
    });
  };

  const updateScrollPadding = () => {
    scrollPadding = parseInt(getComputedStyle(innerEl).paddingLeft);
  };

  window.addEventListener("resize", updateScrollPadding);
  innerEl.addEventListener("scroll", updateOffsets);
  updateScrollPadding();
  updateOffsets();
}

function navigation(wrapperEl) {
  const dotsEl = wrapperEl.querySelector(".cards-navigation-dots");
  // the scrolling div
  const innerEl = wrapperEl.querySelector(".cards-inner");
  const dots = [];
  const buttonPrev = wrapperEl.querySelector(".cards-navigation-arrows-prev");
  const buttonNext = wrapperEl.querySelector(".cards-navigation-arrows-next");
  let scrollPadding;
  const scrollBehavior = {
    behavior: "smooth",
    block: "nearest",
    inline: "center",
  };
  let activeIndex = 0;

  const cardEls = wrapperEl.querySelectorAll(".card");

  buttonPrev.addEventListener("click", () => {
    [...cardEls][activeIndex - 1]?.scrollIntoView(scrollBehavior);
  });
  buttonNext.addEventListener("click", () => {
    [...cardEls][activeIndex + 1]?.scrollIntoView(scrollBehavior);
  });

  cardEls.forEach((el, index) => {
    const dot = document.createElement("button");
    dot.setAttribute("aria-label", `Zu Karte ${index + 1} scrollen`);
    dot.classList.add("cards-navigation-dot");
    dot.addEventListener("click", () => {
      el.scrollIntoView(scrollBehavior);
    });
    dotsEl.appendChild(dot);
    dots.push(dot);
    el.addEventListener("click", () => {
      if (index !== activeIndex) {
        el.scrollIntoView(scrollBehavior);
      }
    });
  });

  const updateScrollPadding = () => {
    scrollPadding = parseInt(getComputedStyle(innerEl).paddingLeft);
  };

  const onScroll = () => {
    activeIndex = [...cardEls]
      .map((cardEl) => {
        return (
          cardEl.getBoundingClientRect().left -
          scrollPadding +
          cardEl.getBoundingClientRect().width / 2
        );
      })
      .findIndex((scrollOffset) => scrollOffset >= 0);

    buttonPrev.classList.toggle("hidden", innerEl.scrollLeft === 0);
    buttonNext.classList.toggle(
      "hidden",
      innerEl.scrollLeft === innerEl.scrollWidth - innerEl.clientWidth
    );
    cardEls.forEach((el, index) => {
      el.classList.toggle("next", index > activeIndex);
      el.classList.toggle("prev", index < activeIndex);
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle(
        "cards-navigation-dot-active",
        index === activeIndex
      );
    });
  };

  innerEl.addEventListener("scroll", onScroll);
  window.addEventListener("resize", updateScrollPadding);
  updateScrollPadding();
  onScroll();
}
